import React, { Component } from "react";

export class ListExamRoutine extends Component {
  render() {
    return <div>ListExamRoutine</div>;
  }
}

export default ListExamRoutine;
